import * as React from "react";
import { RenderMainHeading } from "../RenderMainHeading";
import { RenderSubheading } from "../RenderSubheading";
import { ToggleOddsBtnType } from "../..";
import { CardType } from "../../../../../data";
import { League } from "../../../../../contracts";

export class RenderFavorites extends React.Component<{
    state: any
    cms: any
    name: string
    getMarketNames: Function
    getEvents: Function
}, {}> {

    renderToggleOddsBtn(index: number): ToggleOddsBtnType {
        return {
            shouldShow: index === 0 && this.props.state.isMiniEventCard,
            toggled: this.props.state.showOddBtns,
            tooltipMessage: this.props.state.tooltipMessage,
            onClick: this.props.state.toggleOddsBtnOnClick
        }
    }
    render() {
        let renderedSubheadings = 0;
        const headingId = this.props.state.sports[0];
        const config = this.props.state.options.dataProvider.cardConfiguration[headingId]
            || this.props.state.options.dataProvider.cardConfiguration[0]

        const mainHeading = {
            id: headingId,
            name: this.props.name,
            sportId: ""
        }
        return <RenderMainHeading
            key={`favorites-section-${mainHeading.id}`}
            id={`favorite-section-${mainHeading.id}`}
            name={mainHeading.name}
            eventsCountLength={this.props.state.displayFavoriteEvents.length}
            cms={{
                ShowLivePhraseBeforeSportName: false,
                ShowSportEventsCount: this.props.cms.ShowSportEventsCount
            }}
            dict={{}}
            shouldCollapse={false}
            toggleOddsBtn={this.renderToggleOddsBtn(0)}
            marketNames={[]}
            marketTemplates={[]}
            cardType={CardType.Regular}
            >
            {this.props.state.displayFavoriteLeagues.map(
                (league: League) => {
                    return <RenderSubheading
                        key={`subheading-${league.id}`}
                        id={league.id}
                        name={league.name}
                        eventsCountLength={this.props.state.displayFavoriteEventsByLeague(league.id).length}
                        cms={{
                            ExpandedGroupItems: this.props.cms.ExpandedGroupItems,
                            ShowLeaguesEventsCount: this.props.cms.ShowLeaguesEventsCount
                        }}
                        marketNames={this.props.getMarketNames({...mainHeading, sportId: league.sportId})}
                        marketTemplates={[]}
                        renderedSubheadings={renderedSubheadings++}
                        cardType={config.cardType}>
                        {this.props.getEvents(0, this.props.state.displayFavoriteEventsByLeague(league.id), {id: headingId}, league)}
                    </RenderSubheading>
                }
            )}
        </RenderMainHeading>
    }
}